import script from "./userDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./userDetail.vue?vue&type=script&setup=true&lang=js"

import "./userDetail.vue?vue&type=style&index=0&id=fb3d1c56&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb3d1c56"]])

export default __exports__